import { PaletteOptions, SimplePaletteColorOptions } from "@mui/material/styles";
import paletteValues from "./data";

/**
 * `primary.onDark` fallback for brands that don't define one: the brand panel's
 * body-text white, so no brand inherits Contanuity teal or a low-contrast primary.
 */
const ON_DARK_FALLBACK = "rgba(255, 255, 255, 0.8)";

function withOnDark(options: PaletteOptions | undefined) {
  if (!options) return options;
  const primary = options.primary as SimplePaletteColorOptions | undefined;
  if (!primary || primary.onDark) return options;
  return { ...options, primary: { ...primary, onDark: ON_DARK_FALLBACK } };
}

const palette = (value: string) =>
  withOnDark(value ? paletteValues[value] : paletteValues["palette1"]);

export default palette;

declare module "@mui/material/styles" {
  interface Palette {
    accent: Palette["primary"];
    tertiary: Palette["primary"];
    quaternary: Palette["primary"];
    negative: Palette["primary"];
    positive: Palette["primary"];
    inactive: Palette["primary"];
  }
  interface PaletteOptions {
    accent: PaletteOptions["primary"];
    tertiary: PaletteOptions["primary"];
    quaternary: PaletteOptions["primary"];
    negative: PaletteOptions["primary"];
    positive: PaletteOptions["primary"];
    inactive: Palette["primary"];
  }

  interface PaletteColor {
    darker?: string;
    /** Bright accent for icons/dots on dark (secondary.main) surfaces. Always set on `primary`. */
    onDark?: string;
  }
  interface SimplePaletteColorOptions {
    darker?: string;
    onDark?: string;
  }
}
